module.exports = __webpack_public_path__ + "img/venueone-pricetitle.c5dbb508.png";